import html2canvas from "html2canvas-render-offscreen";

window.getAnchorUrlByTitle = function (title) {
    const element = document.querySelector(`[data-step-title="${title}"]`);
    if (element) {
        const id = $(element).attr('id');
        let baseUrl = location.href;
        if(location.href.indexOf('/#') > -1) {
            baseUrl = location.href.substr(0, location.href.indexOf('/#'));
        }
        return baseUrl + '/#' + id;
    }
    return '';
}

window.jumpToStepByTitle = function (title) {
    const url = getAnchorUrlByTitle(title);
    if (url !== '') {
        location.href = url;
    } else {
        console.log('URL not found for title');
    }
};

window.renderDashboardImage = function () {
    const $circles = $('#dashboard .progress-circle');
    $circles.addClass('temp-image');
    const element = document.querySelector("#dashboard");
    $('#dashboard-warning').hide();
    html2canvas(element, {
        background: '#FFFFFF',
    })
        .then(canvas => {
            const url = canvas.toDataURL("image/png");
            $('#download-dashboard-button').attr('href', url);
            $circles.removeClass('temp-image');
            $('#dashboard-warning').show();
        });
};

$(document).ready(function () {
    if($('#download-dashboard-button').length) {
        renderDashboardImage();
    }

    // Autoselect checkboxes for "otherwise" inputs
    $('.rt-select-otherwise .rt-select-text').on('focus', function (e) {
        $(e.currentTarget)
            .prev('.rt-select-box')
            .prop('checked', true);
    });
    $('.rt-select-otherwise .rt-select-box').on('click', function (e) {
        const checkbox = $(e.currentTarget);
        if (checkbox.is(':checked')) {
            checkbox.next('.rt-select-text').focus();
        }
    });

    // Hide dependent questions when necessary
    let dependencies = {};
    const findQuestionElement = function (questionId) {
        return $('[data-question-id=' + questionId + ']');
    };
    // Hides/shows a dependent question depending on the current value of its
    // answer dependency checkboxes
    const checkDependency = function (d, el) {
        if (!d) return;
        const checkboxes = d.checkboxes;
        // at least 1 valid answer is checked
        const visible = checkboxes.some(function (cb) {
            return $(cb).prop('checked');
        });
        if (visible) {
            if (d.questionEl && d.question in dependencies) {
                checkDependency(dependencies[d.question], el);
            } else {
                el.show();
            }
        } else {
            el.hide();
        }
    };

    // build dependency map from data attributes in the DOM
    const dependentQuestions = $('[data-depend-question]');
    dependentQuestions.each(function () {
        const el = $(this);
        const questionId = el.data('question-id');
        const dependencyId = el.data('depend-question');
        const dependAnswers = (el.data('depend-answers') + '').split(',');
        const dependency = findQuestionElement(dependencyId);
        const checkboxes = dependAnswers.map(function (answerId) {
            return dependency.find('[data-answer-id=' + answerId + ']');
        });
        dependencies[questionId] = {
            el: el,
            question: dependencyId,
            questionEl: dependency,
            answers: dependAnswers,
            checkboxes: checkboxes,
            allCheckboxes: dependency.find('[data-answer-id]').toArray()
        };
    });

    for (const questionId in dependencies) if (dependencies.hasOwnProperty(questionId)) {
        // find all checkboxes that might change the visibility state of this question,
        // so that includes all checkboxes in recursive dependencies
        let checkboxes = dependencies[questionId].allCheckboxes;
        let parent = dependencies[questionId].question;
        while (parent && dependencies[parent]) {
            if (dependencies[parent].allCheckboxes) {
                checkboxes = checkboxes.concat(dependencies[parent].allCheckboxes);
            }
            parent = dependencies[parent].question;
        }

        // wrap in IIFE to get the right questionId value…
        (function (d) {
            $(checkboxes).on('click', function () {
                checkDependency(d, d.el);
            });
            checkDependency(d, d.el);
        }(dependencies[questionId]));
    }

    $('[data-toggle="popover"]').popover();
});
